import { route } from 'preact-router';
import * as clientsApi from '../../api/clients';
import { success, currentClient, error } from '../state';
import { askConfirm } from '../confirm';
import { loadData } from './data.actions';

export async function crearCliente(payload: Record<string, unknown>) {
  await clientsApi.crearCliente(payload);
  await loadData();
}

export async function editarCliente(id: string, data: Record<string, unknown>) {
  await clientsApi.editarCliente(id, data);
  await loadData();
}

export async function eliminarCliente(id: string) {
  const ok = await askConfirm(
    'Desactivar cliente',
    'Se cancelarán sus visitas pendientes. Esta acción no se puede deshacer.',
    true
  );
  if (!ok) return;
  try {
    await clientsApi.eliminarCliente(id);
    success.value = 'Cliente desactivado.';
    currentClient.value = null;
    await loadData();
    route('/clientes');
  } catch (err) {
    error.value = (err as Error).message;
  }
}
